import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { IconButton, InputAdornment } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import {styled} from "@mui/material/styles";

const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
    '& .MuiInputBase-root': {
        padding: theme.spacing(0, 0.5),
        backgroundColor: theme.palette.background.paper,
        '& .MuiIconButton-root': {
            borderRadius: '0.5rem',
            '&:hover': {
                backgroundColor: theme.palette.info.light,
            },
        },
    },
}));

export const MonthSelector = ({
  value = dayjs(),
  // 'name' prop add kiya gaya
  name = 'month',
  onChange = () => {},
  label = 'Month',
  fullWidth = false,
  disableFuture = false,
  disablePast = false,
  minDate = null,
  maxDate = null,
}) => {

    const safeValue = dayjs(value).isValid() ? dayjs(value) : dayjs();

    // Naya onChange handler banaya jo uniform format mein data pass karega
    const handleMonthChange = (date) => {
        onChange({ target: { name, value: date } });
    };

    const handlePreviousMonth = (event) => {
        event.stopPropagation();
        const previousMonth = safeValue.subtract(1, 'month');
        if (minDate && previousMonth.isBefore(dayjs(minDate), 'month')) {
            return;
        }
        handleMonthChange(previousMonth);
    };

    const handleNextMonth = (event) => {
        event.stopPropagation();
        const nextMonth = safeValue.add(1, 'month');
        if (maxDate && nextMonth.isAfter(dayjs(maxDate), 'month')) {
            return;
        }
        handleMonthChange(nextMonth);
    };

    const isPastDisabled = disablePast || (minDate && safeValue.isSame(dayjs(minDate), 'month'));
    const isFutureDisabled = disableFuture || (maxDate && safeValue.isSame(dayjs(maxDate), 'month'));

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StyledDatePicker
                views={['year', 'month']}
                label={label}
                value={safeValue}
                format="MMM YYYY"
                sx={{maxWidth:'200px'}}
                onChange={handleMonthChange} // Naya handler use kiya
                disableFuture={disableFuture}
                disablePast={disablePast}
                minDate={minDate}
                maxDate={maxDate}
                slotProps={{
                    textField: {
                        fullWidth: fullWidth,
                        InputProps: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton onClick={handlePreviousMonth} disabled={isPastDisabled}>
                                        <ChevronLeft />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleNextMonth} disabled={isFutureDisabled}>
                                        <ChevronRight />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

MonthSelector.propTypes = {
    value: PropTypes.any,
    name: PropTypes.string, // Naya propType
    onChange: PropTypes.func,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    disableFuture: PropTypes.bool,
    disablePast: PropTypes.bool,
    minDate: PropTypes.any,
    maxDate: PropTypes.any,
};